// PGCET MCA Mock 7 — General English (questions 91–100)
const PASSAGE = "\"Bengaluru's rise as India's technology capital was not an accident. Decades before software firms arrived, the city already hosted public-sector giants such as HAL, BEL and ISRO, along with the Indian Institute of Science. These institutions created a pool of trained engineers and a culture of research. When liberalisation opened the economy in the early 1990s, global companies found a ready workforce, a pleasant climate and comparatively low costs. Yet rapid growth has brought its own problems: traffic congestion, shrinking lakes and a strained water supply now threaten the very quality of life that once attracted talent. Urban planners argue that the city's future depends less on attracting new investment than on managing the growth it already has.\"";

const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the correct word to fill the blank: She has been working in this company ______ 2019.",
    options: ["A. for", "B. from", "C. since", "D. by"],
    answer: "C"
  },
  {
    id: 92,
    question: "Choose the correct word to fill the blank: If I ______ you, I would apologise to him at once.",
    options: ["A. am", "B. was being", "C. had been", "D. were"],
    answer: "D"
  },
  {
    id: 93,
    question: "Choose the correct word to fill the blank: The scientist's theory was ______ by the new experimental data, as every one of its predictions proved correct.",
    options: ["A. vindicated", "B. undermined", "C. refuted", "D. obscured"],
    answer: "A"
  },
  {
    id: 94,
    question: "Choose the correct meaning of the idiom \"to burn the midnight oil\".",
    options: ["A. To waste resources", "B. To work or study late into the night", "C. To start a quarrel", "D. To be extremely angry"],
    answer: "B"
  },
  {
    id: 95,
    question: "Choose the correct meaning of the idiom \"a red herring\".",
    options: ["A. A rare opportunity", "B. A dangerous person", "C. Something that diverts attention from the real issue", "D. An embarrassing secret"],
    answer: "C"
  },
  {
    id: 96,
    question: "Improve the sentence by choosing the correct replacement for \"senior than me\": He is senior than me in the office.",
    options: ["A. senior to me", "B. more senior than me", "C. senior from me", "D. No improvement"],
    answer: "A"
  },
  {
    id: 97,
    question: "Improve the sentence by choosing the correct replacement for \"The furniture were delivered\": The furniture were delivered yesterday.",
    options: ["A. The furnitures were delivered", "B. The furniture was delivered", "C. The furnitures was delivered", "D. No improvement"],
    answer: "B"
  },
  {
    id: 98,
    question: `Read the passage and answer the question: ${PASSAGE} According to the passage, what mainly drew global companies to Bengaluru?`,
    options: ["A. Government tax holidays", "B. Its proximity to sea ports", "C. Its abundant water supply", "D. A ready pool of trained engineers built up by earlier institutions"],
    answer: "D"
  },
  {
    id: 99,
    question: `Read the passage and answer the question: ${PASSAGE} Which of the following problems is NOT mentioned in the passage?`,
    options: ["A. Traffic congestion", "B. Shrinking lakes", "C. Air pollution", "D. Strained water supply"],
    answer: "C"
  },
  {
    id: 100,
    question: `Read the passage and answer the question: ${PASSAGE} What do urban planners believe about the city's future?`,
    options: ["A. Bengaluru must attract much more foreign investment", "B. Managing existing growth matters more than attracting new investment", "C. Public-sector firms should move out of the city", "D. All further growth should be stopped"],
    answer: "B"
  }
];

export default pgcetmcaGeneralEnglish;
